(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["retail-navigation-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('retail-menu-drawer')) {
    customElements.define(
      'retail-menu-drawer',
      class RetailMenuDrawer extends HTMLElement {
        connectedCallback() {
          this.root = this.querySelector(':scope > details');
          this.trigger = this.root.querySelector(':scope > summary');
          this.panel = this.root.querySelector(':scope > .retail-drawer__panel');
          this.overlay = this.root.querySelector(':scope > .retail-drawer__overlay');
          this.accordions = [...this.panel.querySelectorAll('details')];
          this.header = document.querySelector('.section-header');
          this.borderOffset = this.closest('.header-wrapper')?.classList.contains('header-wrapper--border-bottom') ? 1 : 0;
          this.handleKeyDown = this.handleKeyDown.bind(this);
          this.handleResize = this.updateViewportMetrics.bind(this);

          this.root.addEventListener('toggle', () => this.handleRootToggle());
          this.overlay.addEventListener('click', () => this.close(true));
          this.accordions.forEach((accordion) => {
            accordion.addEventListener('toggle', () => this.handleAccordionToggle(accordion));
          });
          document.addEventListener('keydown', this.handleKeyDown);
        }

        disconnectedCallback() {
          document.removeEventListener('keydown', this.handleKeyDown);
          window.removeEventListener('resize', this.handleResize);
        }

        handleRootToggle() {
          this.trigger.setAttribute('aria-expanded', String(this.root.open));
          document.body.classList.toggle(`overflow-hidden-${this.dataset.breakpoint}`, this.root.open);
          if (this.root.open) {
            this.updateViewportMetrics();
            window.addEventListener('resize', this.handleResize);
            trapFocus(this.root, this.trigger);
          } else {
            window.removeEventListener('resize', this.handleResize);
            this.accordions.forEach((accordion) => this.setAccordionState(accordion, false));
            removeTrapFocus();
          }
        }

        updateViewportMetrics() {
          const headerBottom = this.header ? this.header.getBoundingClientRect().bottom - this.borderOffset : 0;
          document.documentElement.style.setProperty('--header-bottom-position', `${Math.max(0, Math.floor(headerBottom))}px`);
          document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
        }

        handleAccordionToggle(accordion) {
          this.setAccordionState(accordion, accordion.open);
          if (!accordion.open) return;
          const siblingAccordions = accordion.parentElement.parentElement.querySelectorAll(':scope > li > details[open]');
          siblingAccordions.forEach((sibling) => {
            if (sibling !== accordion) this.setAccordionState(sibling, false);
          });
        }

        setAccordionState(accordion, open) {
          accordion.open = open;
          accordion.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(open));
        }

        handleKeyDown(event) {
          if (event.key !== 'Escape' || !this.root.open) return;
          const nested = event.target.closest('.retail-drawer__accordion[open]');
          event.preventDefault();
          if (nested) {
            const summary = nested.querySelector(':scope > summary');
            this.setAccordionState(nested, false);
            summary.focus();
          } else {
            this.close(true);
          }
        }

        close(restoreFocus = false) {
          if (!this.root.open) return;
          this.root.open = false;
          this.trigger.setAttribute('aria-expanded', 'false');
          document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
          removeTrapFocus(restoreFocus ? this.trigger : null);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["retail-navigation-mega-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('retail-mega-navigation')) {
    customElements.define(
      'retail-mega-navigation',
      class RetailMegaNavigation extends HTMLElement {
        connectedCallback() {
          this.details = [...this.querySelectorAll(':scope details')];
          this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.pointerQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
          this.openTimer = null;
          this.closeTimer = null;
          this.lastTrigger = null;
          this.pointerFocusTrigger = null;
          this.suppressFocusOpen = false;
          this.handlePointerDown = this.handlePointerDown.bind(this);
          this.handleKeyDown = this.handleKeyDown.bind(this);
          this.promoRailCleanups = [...this.querySelectorAll('[data-retail-promo-rail]')].map((rail) =>
            this.setupPromoRail(rail)
          );
          this.submenuCleanups = [...this.querySelectorAll('[data-retail-submenu-list]')].map((list) =>
            this.setupSubmenuExplorer(list)
          );

          this.details.forEach((details) => {
            const summary = details.querySelector(':scope > summary');
            details.addEventListener('toggle', () => this.handleToggle(details));
            summary.addEventListener('focus', () => {
              if (!this.suppressFocusOpen && this.pointerFocusTrigger !== summary) {
                this.clearTimers();
                this.open(details);
              }
            });
            summary.addEventListener('pointerdown', () => {
              this.pointerFocusTrigger = summary;
            });
            summary.addEventListener('click', () => {
              this.clearTimers();
              this.pointerFocusTrigger = null;
            });
            summary.addEventListener('pointercancel', () => {
              this.pointerFocusTrigger = null;
            });
            details.addEventListener('pointerenter', () => this.handlePointerEnter(details));
            details.addEventListener('pointerleave', () => this.handlePointerLeave(details));
          });

          document.addEventListener('pointerdown', this.handlePointerDown);
          document.addEventListener('keydown', this.handleKeyDown);
        }

        disconnectedCallback() {
          document.removeEventListener('pointerdown', this.handlePointerDown);
          document.removeEventListener('keydown', this.handleKeyDown);
          this.promoRailCleanups.forEach((cleanup) => cleanup());
          this.submenuCleanups.forEach((cleanup) => cleanup());
          this.clearTimers();
        }

        setupSubmenuExplorer(list) {
          const container = list.closest('.retail-navigation__panel-inner');
          const triggers = [...list.querySelectorAll('[data-retail-submenu-trigger]')];
          const panels = [...container.querySelectorAll('[data-retail-submenu-panel]')];
          const promoRail = container.querySelector('[data-retail-promo-rail]');
          const sharedHeading = container.querySelector('[data-retail-submenu-heading]');
          let hoverTimer = null;

          const activate = (activeTrigger) => {
            const activePanelId = activeTrigger.getAttribute('aria-controls');
            const activeHandle = activeTrigger.dataset.retailSubmenuHandle || '';
            if (sharedHeading) sharedHeading.textContent = activeTrigger.dataset.retailSubmenuLabel || '';
            triggers.forEach((trigger) => {
              trigger.setAttribute('aria-expanded', String(trigger === activeTrigger));
            });
            panels.forEach((panel) => {
              const isActive = panel.id === activePanelId;
              panel.dataset.active = String(isActive);
              panel.setAttribute('aria-hidden', String(!isActive));
            });
            promoRail?.dispatchEvent(new CustomEvent('retail:submenu-change', { detail: { handle: activeHandle } }));
          };
          const handlers = triggers.map((trigger) => {
            const handlePointerEnter = () => {
              if (!this.pointerQuery.matches) return;
              window.clearTimeout(hoverTimer);
              hoverTimer = window.setTimeout(() => activate(trigger), 90);
            };
            const handleFocus = () => {
              window.clearTimeout(hoverTimer);
              activate(trigger);
            };
            trigger.addEventListener('pointerenter', handlePointerEnter);
            trigger.addEventListener('focus', handleFocus);
            return { trigger, handlePointerEnter, handleFocus };
          });
          const clearHoverTimer = () => window.clearTimeout(hoverTimer);
          const initialTrigger = triggers.find((trigger) => trigger.getAttribute('aria-expanded') === 'true') || triggers[0];

          list.addEventListener('pointerleave', clearHoverTimer);
          if (initialTrigger) activate(initialTrigger);

          return () => {
            handlers.forEach(({ trigger, handlePointerEnter, handleFocus }) => {
              trigger.removeEventListener('pointerenter', handlePointerEnter);
              trigger.removeEventListener('focus', handleFocus);
            });
            list.removeEventListener('pointerleave', clearHoverTimer);
            window.clearTimeout(hoverTimer);
          };
        }

        setupPromoRail(rail) {
          const track = rail.querySelector('[data-retail-promo-track]');
          const controls = rail.querySelector('[data-retail-promo-controls]');
          const previous = rail.querySelector('[data-retail-promo-previous]');
          const next = rail.querySelector('[data-retail-promo-next]');
          const cards = [...track.querySelectorAll('[data-retail-promo-subsection]')];
          let animationFrame = null;

          const update = () => {
            animationFrame = null;
            const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
            const overflowing = maximum > 1;
            rail.dataset.overflowing = String(overflowing);
            controls.hidden = !overflowing;
            previous.disabled = track.scrollLeft <= 1;
            next.disabled = track.scrollLeft >= maximum - 1;
          };
          const scheduleUpdate = () => {
            if (animationFrame) return;
            animationFrame = window.requestAnimationFrame(update);
          };
          const filterCards = (activeHandle = '') => {
            let visibleCards = 0;
            rail.dataset.retailActiveSubsection = activeHandle;
            cards.forEach((card) => {
              const subsection = card.dataset.retailPromoSubsection || '';
              const isVisible = subsection === '' || subsection === activeHandle;
              card.hidden = !isVisible;
              if (isVisible) visibleCards += 1;
            });
            rail.dataset.empty = String(visibleCards === 0);
            track.scrollLeft = 0;
            scheduleUpdate();
          };
          const handleSubsectionChange = (event) => filterCards(event.detail?.handle || '');
          const scroll = (direction) => {
            const card = track.querySelector('.retail-navigation__promo:not([hidden])');
            const gap = Number.parseFloat(window.getComputedStyle(track).columnGap) || 0;
            const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
            track.scrollBy({
              left: direction * distance,
              behavior: this.motionQuery.matches ? 'auto' : 'smooth',
            });
          };
          const showPrevious = () => scroll(-1);
          const showNext = () => scroll(1);
          const resizeObserver = new ResizeObserver(scheduleUpdate);

          previous.addEventListener('click', showPrevious);
          next.addEventListener('click', showNext);
          rail.addEventListener('retail:submenu-change', handleSubsectionChange);
          track.addEventListener('scroll', scheduleUpdate, { passive: true });
          resizeObserver.observe(track);
          filterCards(rail.dataset.retailActiveSubsection || '');

          return () => {
            previous.removeEventListener('click', showPrevious);
            next.removeEventListener('click', showNext);
            rail.removeEventListener('retail:submenu-change', handleSubsectionChange);
            track.removeEventListener('scroll', scheduleUpdate);
            resizeObserver.disconnect();
            if (animationFrame) window.cancelAnimationFrame(animationFrame);
          };
        }

        handleToggle(details) {
          const summary = details.querySelector(':scope > summary');
          summary.setAttribute('aria-expanded', String(details.open));
          if (details.open) {
            this.lastTrigger = summary;
            this.closeOthers(details);
          }
        }

        handlePointerEnter(details) {
          if (!this.pointerQuery.matches) return;
          window.clearTimeout(this.closeTimer);
          window.clearTimeout(this.openTimer);
          this.openTimer = window.setTimeout(() => this.open(details, false), 150);
        }

        handlePointerLeave(details) {
          if (!this.pointerQuery.matches) return;
          window.clearTimeout(this.openTimer);
          this.closeTimer = window.setTimeout(() => this.close(details), 250);
        }

        handlePointerDown(event) {
          if (this.contains(event.target)) return;
          const openDetails = this.details.find((details) => details.open);
          if (!openDetails) return;
          this.clearTimers();
          const trigger = openDetails.querySelector(':scope > summary');
          this.closeAll();
          window.requestAnimationFrame(() => this.restoreTriggerFocus(trigger));
        }

        handleKeyDown(event) {
          if (event.key !== 'Escape') return;
          const openDetails = this.details.find((details) => details.open);
          if (!openDetails) return;
          event.preventDefault();
          this.clearTimers();
          const trigger = openDetails.querySelector(':scope > summary');
          this.closeAll();
          this.restoreTriggerFocus(trigger);
        }

        restoreTriggerFocus(trigger) {
          this.suppressFocusOpen = true;
          trigger.focus({ preventScroll: true });
          window.setTimeout(() => {
            this.suppressFocusOpen = false;
          }, 0);
        }

        clearTimers() {
          window.clearTimeout(this.openTimer);
          window.clearTimeout(this.closeTimer);
          this.openTimer = null;
          this.closeTimer = null;
        }

        open(details, useViewTransition = true) {
          if (details.open) return;
          const currentlyOpen = this.details.find((item) => item.open && item !== details);
          const update = () => {
            if (currentlyOpen) this.close(currentlyOpen);
            details.open = true;
            details.querySelector(':scope > summary').setAttribute('aria-expanded', 'true');
          };

          if (useViewTransition && currentlyOpen && document.startViewTransition && !this.motionQuery.matches) {
            document.startViewTransition(update);
          } else {
            update();
          }
        }

        close(details) {
          details.open = false;
          details.querySelector(':scope > summary').setAttribute('aria-expanded', 'false');
        }

        closeOthers(current) {
          this.details.forEach((details) => {
            if (details !== current && details.open) this.close(details);
          });
        }

        closeAll() {
          this.details.forEach((details) => {
            if (details.open) this.close(details);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sale-price-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sale-price-countdown')) {
    customElements.define(
      'sale-price-countdown',
      class SalePriceCountdown extends HTMLElement {
        connectedCallback() {
          this.digitsElement = this.querySelector('[data-sale-countdown-digits]');

          if (!this.digitsElement) return;

          this.disconnectedCallback();

          try {
            this.partsFormatter = new Intl.DateTimeFormat('en-US-u-ca-gregory-nu-latn', {
              timeZone: 'America/New_York',
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hourCycle: 'h23',
            });

            this.updateCountdown();
            this.hidden = false;
            this.intervalId = window.setInterval(() => this.updateCountdown(), 1000);
          } catch (error) {
            this.hidden = true;
          }
        }

        disconnectedCallback() {
          if (!this.intervalId) return;

          window.clearInterval(this.intervalId);
          this.intervalId = null;
        }

        getTimeZoneParts(date) {
          const values = {};

          for (const part of this.partsFormatter.formatToParts(date)) {
            if (part.type !== 'literal') values[part.type] = Number(part.value);
          }

          return values;
        }

        getTimeZoneOffset(date) {
          const parts = this.getTimeZoneParts(date);
          const representedAsUtc = Date.UTC(
            parts.year,
            parts.month - 1,
            parts.day,
            parts.hour,
            parts.minute,
            parts.second,
          );

          return representedAsUtc - date.getTime();
        }

        getZonedInstant(year, month, day) {
          const desiredAsUtc = Date.UTC(year, month - 1, day, 0, 0, 0);
          let candidate = desiredAsUtc;

          for (let attempt = 0; attempt < 3; attempt += 1) {
            const adjusted = desiredAsUtc - this.getTimeZoneOffset(new Date(candidate));

            if (adjusted === candidate) break;
            candidate = adjusted;
          }

          return candidate;
        }

        getNextMidnight(now) {
          const easternNow = this.getTimeZoneParts(now);
          const nextDate = new Date(Date.UTC(easternNow.year, easternNow.month - 1, easternNow.day + 1));

          return this.getZonedInstant(
            nextDate.getUTCFullYear(),
            nextDate.getUTCMonth() + 1,
            nextDate.getUTCDate(),
          );
        }

        updateCountdown() {
          const now = new Date();
          const nextMidnight = this.getNextMidnight(now);
          const totalSeconds = Math.max(0, Math.ceil((nextMidnight - now.getTime()) / 1000));
          const hours = Math.floor(totalSeconds / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;

          this.digitsElement.textContent = [hours, minutes, seconds]
            .map((value) => String(value).padStart(2, '0'))
            .join(':');
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

})();
